/** Browser routes for the client portal — /{client-slug}/… not /portal/… */

export const RESERVED_APP_SEGMENTS = new Set([
  "admin",
  "verify",
  "onboarding",
  "portal",
  "api",
  "agreement",
  "scope",
  "privacy",
]);

export function slugifyClientName(name) {
  const s = String(name || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "");
  return s || "client";
}

export function clientSlug(client) {
  const stored = String(client?.slug || "").trim().replace(/-/g, "");
  if (stored) return stored;
  return slugifyClientName(client?.name);
}

export function portalBasePath(client) {
  return `/${clientSlug(client)}`;
}

export function portalPath(client, subpath = "") {
  const base = portalBasePath(client);
  const rest = String(subpath || "").replace(/^\//, "");
  return rest ? `${base}/${rest}` : base;
}

/** Public proposal review: /{company}/proposal */
export function proposalPath(client) {
  return portalPath(client, "proposal");
}

export function proposalPathForSlug(slug) {
  const s = String(slug || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "");
  return s ? `/${s}/proposal` : "/proposal";
}

/** Agreement preview / partner share: /agreement/preview/{company} */
export function agreementPreviewPath(client) {
  const slug = clientSlug(client);
  return slug ? `/agreement/preview/${slug}` : "/agreement/preview/client";
}

export function agreementPreviewPathForSlug(slug) {
  const s = slugifyClientName(String(slug || "").replace(/-/g, ""));
  return s ? `/agreement/preview/${s}` : "/agreement/preview/client";
}

export function isReservedAppSegment(segment) {
  return RESERVED_APP_SEGMENTS.has(String(segment || "").toLowerCase());
}

export function isPortalBrowserPath(path) {
  if (!path || path === "/") return false;
  const seg = path.split("/").filter(Boolean)[0];
  if (!seg || isReservedAppSegment(seg)) return false;
  return true;
}

/** Rewrite legacy /portal/… links (notifications, bookmarks) to the client slug URL. */
export function migrateLegacyPortalPath(path, client) {
  if (!path || !client) return path;
  if (!path.startsWith("/portal")) return path;
  const qIdx = path.indexOf("?");
  const pathname = qIdx >= 0 ? path.slice(0, qIdx) : path;
  const search = qIdx >= 0 ? path.slice(qIdx) : "";
  const rest = pathname.replace(/^\/portal\/?/, "");
  return `${portalPath(client, rest)}${search}`;
}

export function portalSectionFromPath(pathname) {
  const segments = String(pathname || "").split("/").filter(Boolean);
  return segments[1] || "";
}
